import React from 'react';
import { Card } from '@material-ui/core';
import CreateMovieFrom from './CreateMovieFrom';
import PageContainer from '@jumbo/components/PageComponents/layouts/PageContainer';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { useLocation } from 'react-router';

const useStyles = makeStyles(theme => ({
  cardRoot: {
    padding: 50,
  },
}));

const CreateMovies = () => {
  const location = useLocation();
  const classes = useStyles();

  const params = new URLSearchParams(location.search);
  
  const movieName = params.get('name');

  return (
    <PageContainer heading={`ساخت دانلود آیتم ${movieName}`}>
      <Card className={classes.cardRoot}>
        <CreateMovieFrom />
      </Card>
    </PageContainer>
  );
};

export default CreateMovies;
